export default "__VITE_ASSET__Dx6TlzMG__"